import axios from 'axios'
import router from '@/router'

function getDeviceId() {
  let deviceId = localStorage.getItem('device_id')

  if (!deviceId) {

    if (window.crypto && crypto.randomUUID) {
      deviceId = crypto.randomUUID()
    } else {
      deviceId =
        'dev-' +
        Date.now() +
        '-' +
        Math.random().toString(36).substring(2)
    }

    localStorage.setItem('device_id', deviceId)
  }

  return deviceId
}

const apiClient = axios.create({
  baseURL: 'https://portal-web.laygriega.com.mx/api.php?path=',
  //baseURL: 'https://portal-web.laygriega.com.mx/api/',
  //baseURL: 'http://192.169.1.201:8080/InvYGriegaP/index.php/',
  timeout: 8000,
  headers: {
    'Content-Type': 'application/json'
  }
})

apiClient.interceptors.request.use(
  config => {

    const token = localStorage.getItem('token')
    const usuario = localStorage.getItem('usuarioClave')

    const deviceId = getDeviceId()

    const esLogin =
      config.url &&
      config.url.toLowerCase().includes('loginportal')

    // LOGIN
    // enviar deviceId SOLO en body
    if (esLogin) {

      config.data = {
        ...(config.data || {}),
        deviceId: deviceId
      }
    }

    // PETICIONES AUTENTICADAS
    if (!esLogin && token) {

      config.headers.Authorization = `Bearer ${token}`
      config.headers.token = token
    }

    if (!esLogin && usuario) {

      config.headers.usuario = usuario
    }

    return config
  },
  error => Promise.reject(error)
)

apiClient.interceptors.response.use(
  response => response,
  error => {

    if (error.response) {

      const { status } = error.response

      if (status === 401) {

        localStorage.removeItem('token')
        localStorage.removeItem('usuario')
        localStorage.removeItem('usuarioClave')

        localStorage.setItem(
          'loginMessage',
          'Tu sesión fue cerrada porque iniciaste sesión en otro dispositivo.'
        )

        if (router.currentRoute.path !== '/login') {
          router.push('/login')
        }

      } else if (status >= 500) {

        alert('Error interno del servidor, intenta más tarde.')
      }

    } else {

      alert('Error al conectar con el servidor.')
    }

    return Promise.reject(error)
  }
)

export default apiClient